"use client";

import Link from "next/link";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import VideoBackdrop from "@/components/VideoBackdrop";
import InstagramTeaser from "@/components/InstagramTeaser";
import WhatsAppCommunityCard from "@/components/WhatsAppCommunityCard";

// Long-form bio content is hardcoded directly, same posture as the legal pages (see
// LegalPageLayout.tsx) -- this is admin-authored editorial content, not UI chrome, and the only
// facts here are ones already established elsewhere in the project (home.about.body in en.ts,
// the real service/batch details in lib/services.ts and seed.ts), not invented for this page.
export default function AboutPageView() {
  return (
    <>
      <Header />
      <main className="mx-auto w-full max-w-[1440px] px-8 py-10 sm:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:items-center sm:gap-12">
          <Reveal className="relative aspect-[4/5] max-h-[75vh] w-full overflow-hidden rounded-2xl">
            <VideoBackdrop
              webmSrc="/videos/about-hoop.webm"
              mp4Src="/videos/about-hoop.mp4"
              poster="/videos/about-hoop-poster.jpg"
              alt="Devina Prasad performing an LED hoop routine"
              sizes="(max-width: 640px) 100vw, 50vw"
              tintClassName="bg-black/25"
              priority
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent" />
            <Link
              href="/book"
              className="absolute inset-x-6 bottom-6 flex items-center justify-center rounded-xl bg-accent px-6 py-3 text-center font-semibold text-accent-foreground shadow-lg transition hover:scale-[1.02] hover:opacity-90"
            >
              Book a session now
            </Link>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-accent">About</p>
            <h1 className="mt-3 font-display text-4xl sm:text-5xl">Devina Prasad</h1>
            <p className="mt-6 text-lg text-foreground/80">
              Hoop dance artist, choreographer, and yoga coach, based in Bangalore. Devina built
              her own practice from the ground up: hoop flow and choreography for the artistry of
              it, yoga and pregnancy yoga for the discipline. Every session is built around where
              you actually are, not a fixed program.
            </p>
          </Reveal>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:mt-16 sm:grid-cols-3 sm:gap-10">
          <Reveal delay={0.05}>
            <h2 className="font-display text-xl">Hoop dance &amp; choreography</h2>
            <p className="mt-3 text-foreground/70">
              From your first spin to full choreography, LED and fire hoop included, built
              around your body and your music, one on one.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-xl">Yoga &amp; pregnancy yoga</h2>
            <p className="mt-3 text-foreground/70">
              Personal sessions built around strength, breath, and consistency, with
              trimester-aware modifications for expecting mothers.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <h2 className="font-display text-xl">Group classes</h2>
            <p className="mt-3 text-foreground/70">
              Recurring batches, Mon/Wed/Fri, across two skill tiers, taught live online with
              recordings included.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 sm:mt-20">
          <InstagramTeaser />
        </div>
      </main>
      <WhatsAppCommunityCard />
      <Footer />
    </>
  );
}
